import React from "react";
import CpntFormSection from "../../../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../../../components/forms/CpntFormSectionContainer";
import TextInput from "../../../../../components/forms/TextInput";
import SelectInput from "../../../../../components/forms/SelectInput";
import { validationMode } from "../../../../../config/helpers";
import AddressAutocomplete from "../../../../../components/forms/AddressAutocomplete";

interface InscriptionFormSocieteProps {
  pays: any[];
  disabled: boolean;
  isFranceOrAssimile: boolean;
}

const InscriptionFormSociete: React.FC<InscriptionFormSocieteProps> = ({ pays, disabled, isFranceOrAssimile }) => {
  return (
    <div className="col-md-6">
      <div className="card h-100">
        <div className="card-header">
          <h6 className="mb-0 fw-bold">INFORMATIONS SOCIÉTÉ</h6>
        </div>
        <div className="card-body">
          <CpntFormSection pSectionLabel="">
            {isFranceOrAssimile && (
              <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6]}>
                <TextInput
                  label="N° Siren"
                  formName="Siren"
                  validationStyle={validationMode.classic}
                  placeholder="Numéro SIREN (9 chiffres)"
                  disabled={disabled}
                />
                <TextInput
                  label="Raison sociale (SIREN)"
                  formName="RaisonSocialeSiren"
                  validationStyle={validationMode.classic}
                  placeholder="Récupérée automatiquement"
                  disabled={true}
                />
              </CpntFormSectionContainer>
            )}

            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
              <TextInput
                label="Raison sociale"
                formName="RaisonSociale"
                ismandatory={true}
                validationStyle={validationMode.classic}
                placeholder="Raison sociale"
                disabled={disabled}
              />
            </CpntFormSectionContainer>

            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
              <TextInput
                label="Site internet"
                formName="SiteInternet"
                validationStyle={validationMode.classic}
                placeholder="https://www.example.com"
                disabled={disabled}
              />
            </CpntFormSectionContainer>

            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
              <SelectInput
                label="Pays"
                formName="IdPays"
                ismandatory={true}
                optionEmpty="Sélectionnez un pays"
                validationStyle={validationMode.classic}
                options={pays}
                disabled={disabled}
              />
            </CpntFormSectionContainer>

            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
              {!disabled && isFranceOrAssimile ? (
                <AddressAutocomplete ismandatory validationStyle={validationMode.classic} />
              ) : (
                <TextInput
                  label="Adresse"
                  formName="Adresse"
                  ismandatory={true}
                  validationStyle={validationMode.classic}
                  placeholder="Adresse"
                  disabled={disabled}
                />
              )}
            </CpntFormSectionContainer>

            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6]}>
              <TextInput
                label="Code postal"
                formName="CodePostal"
                validationStyle={validationMode.classic}
                placeholder="Code postal"
                disabled={disabled}
                maxLength={11}
              />
              <TextInput
                label="Ville"
                formName="Ville"
                ismandatory={true}
                validationStyle={validationMode.classic}
                placeholder="Ville"
                disabled={disabled}
              />
            </CpntFormSectionContainer>
          </CpntFormSection>
        </div>
      </div>
    </div>
  );
};

export default InscriptionFormSociete;
